module.exports = __webpack_public_path__ + "static/media/solicitud-graduacion.11a6b0d6.pdf";